import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorHandler from '../utils/errorHandler';

const NotificationContainer = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const unsubscribe = errorHandler.subscribe((notification) => {
      if (notification.type === 'remove') {
        setNotifications(prev => prev.filter(n => n.id !== notification.id));
      } else if (notification.type === 'clear') {
        setNotifications([]);
      } else {
        setNotifications(prev => [...prev, notification]);
      }
    });

    // Initialize with current notifications
    setNotifications(errorHandler.getNotifications());

    return unsubscribe;
  }, []);

  const removeNotification = (id) => {
    errorHandler.removeNotification(id);
  };

  const getNotificationClass = (type) => {
    const baseClass = 'notification';
    switch (type) {
      case 'success':
        return `${baseClass} ${baseClass}--success`;
      case 'warning':
        return `${baseClass} ${baseClass}--warning`;
      case 'info':
        return `${baseClass} ${baseClass}--info`;
      case 'error':
      default:
        return `${baseClass} ${baseClass}--error`;
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return '✓';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      case 'error':
      default:
        return '✕';
    }
  };

  return (
    <div className="notification-container" role="region" aria-label="Notifications">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={getNotificationClass(notification.type)}
          role="alert"
          aria-live="polite"
        >
          <div className="notification__content">
            <span className="notification__icon" aria-hidden="true">
              {getIcon(notification.type)}
            </span>
            <span className="notification__message">
              {notification.message}
            </span>
          </div>
          <button
            className="notification__close"
            onClick={() => removeNotification(notification.id)}
            aria-label="Close notification"
            title="Close notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
